<template>
    <modal-centered-base
    :title="t('uploader.editProfilePhoto')"
    :titleIcon="'add-photo'"
    :leftButtonText="t('uploader.cancel')"
    :rightButtonText="t('uploader.save')"
    :rightButtonIcon="'check-line'"
    @hideMe="emit('hideMe')"
    @clicked="emit('hideMe')"
    @rightButtonClicked="emit('saveImage')">
        <div class="modal-body">
            <div class="image-wrapper">
                <!-- Current Selected Image -->
                <img
                class="selected-image"
                :src="currentImage"
                @error="imageErrorHandler"
                @load="imageLoadHandler"/>
            </div>
            <div class="uploader-buttons-container">
                <div class="buttons-section">
                    <button-secondary
                    icon="cycle"
                    :label="t('uploader.replace')"
                    @clicked="emit('fileChange')"/>
                </div>
                <div class="informative-section">
                    <p class="types">{{t('uploader.typeImageMessage')}}</p>
                    <p class="sizes">{{t('uploader.sizeImageMessage')}}</p>
                </div>
            </div>
        </div>
    </modal-centered-base>
</template>

<script setup>
import ModalCenteredBase from '@/components/generic/modals/centered/Base'
import ButtonSecondary from '@/components/generic/buttons/Secondary'

/* Vue */
import { ref, computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'fileChange', 'saveImage', 'handleDelete'])

/** Props received:
@userImageData { Object }
@ourImage {String}
*/
const props = defineProps({
    userImageData: Object,
    ourImage: String
})

const imageIsLoaded = ref(false)

const currentImage = computed(() => {
    return props.userImageData.imageUrl
})

/** validates if image is loaded
@return { void }
*/
const imageLoadHandler = () => {
    imageIsLoaded.value = true
}

/** hangles image load error
@return { void }
*/
const imageErrorHandler = () => {
	imageIsLoaded.value = false
}
</script>

<style lang="scss" scoped>
.modal-body {
    width: 100%;
    height: 120px;
    margin-top: 24px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;

    .image-wrapper {
        width: 120px;
        height: 120px;
        margin-right: 16px;
        border-radius: 50%;

        line-height: 120px;
        text-align: center;

        overflow: hidden;

        .selected-image, .default-image {
            width: 120px;
            height: 120px;

            border-radius: 50%;

            object-fit: cover;
        }
    }

    .uploader-buttons-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .buttons-section {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            gap: 8px;
        }

        .informative-section {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            align-self: flex-start;

            gap: 2px;
            pointer-events: none;

            .types, .sizes {
                @include H9-Regular;
            }
        }
    }
}

</style>
